<template>
  <div class="container fx-sta-cen fx-col">
    <img id="exportImg" ref="exportImg" v-if="scoreImage" :src="scoreImage"
         style="margin-top: 20px;width: calc(100vw - 70px);height: 74%;border-radius: 10px;"/>
    <!--    等比例 object-fit: contain;-->
    <div v-if="!scoreImage" style="font-weight: bold;font-size: 18px;margin-top: 60px;color:#323233;">
      成绩尚未公布
    </div>

    <div v-if="scoreImage" style="color: #FF7216;font-size: 20px;margin-top: 20px">请长按图片 保存到手机</div>

    <div class="fx-cen-cen" style="margin-top: 25px">
      <!--      <div class="fx-cen-cen" v-if="scoreImage"-->
      <!--           @click="saveImg"-->
      <!--           style="background: #FF7216;color: #FFF;height: 35px;font-size: 16px;width: 150px;border-radius: 8px;margin-right: 20px">-->
      <!--        保存-->
      <!--      </div>-->
      <div style="height: 40px;width: 170px;font-size: 16px;" class=" btn fx-cen-cen" @click="back">
        返回
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'MyScore',
  data() {
    return {
      scoreImage: '',
    }
  },
  created(option) {
    this.$http.post('/spInfo/userInfo', {id: this.$route.query.id}).then(res => {
      if (res.data) {
        this.scoreImage = res.data.scoreImage
      }
    })
  },
  activated() {
  },
  methods: {
    back() {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
}

.btn {
  width: 220px;
  height: 40px;
  color: #FF7216;
  border-radius: 5px;
  font-size: 18px;
  border: 1px solid #FF7216;
  background: #FFF;
}


</style>



// WEBPACK FOOTER //
// src/routerPages/info/MyScore.vue